import {theme} from "../../../../../../../../../../../shared/theme";

export const headCells = [
    {
        id: 'numeroDiTelefono',
        disablePadding: true,
        align: 'left',
        width: '160px',
        paddingLeft: '0',
        label: 'Numero di telefono'
    },
    {
        id: 'seriale',
        disablePadding: false,
        align: 'left',
        width: '160px',
        paddingLeft: theme.spacing(4),
        label: 'Seriale'
    },
    {
        id: 'dataOrdineDiConsegna',
        disablePadding: false,
        align: 'left',
        width: '190px',
        paddingLeft: theme.spacing(4),
        label: 'Data ordine di consegna'
    },
    {
        id: 'numeroOrdineDiConsegna',
        disablePadding: false,
        align: 'left',
        width: '210px',
        paddingLeft: theme.spacing(4),
        label: 'Numero ordine di consegna'
    },
]